import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '../api/client';
import type { RangeHealth } from '../api/types';

/**
 * Live per-range health: VM list with SSM ping status, assignment tags,
 * and console protocol. Polls every 15s while mounted so the Workstation
 * tab updates as VMs come online during provisioning.
 *
 * Backend: GET /monitor/ranges/{rangeId}/health (services/monitor/handler.py).
 */
export const rangeHealthKeys = {
  all: ['range-health'] as const,
  detail: (id: string) => ['range-health', id] as const,
};

export function useRangeHealth(rangeId: string | undefined) {
  return useQuery<RangeHealth>({
    queryKey: rangeHealthKeys.detail(rangeId ?? ''),
    enabled: Boolean(rangeId),
    refetchInterval: 15_000,
    refetchOnWindowFocus: true,
    queryFn: async ({ signal }) =>
      apiFetch<RangeHealth>(
        `/monitor/ranges/${encodeURIComponent(rangeId ?? '')}/health`,
        { method: 'GET', signal },
      ),
  });
}
